import React from 'react';
import PropTypes from 'prop-types';
import SiteHeader from '@homeaway/react-site-header';
import Experiment from '@homeaway/react-experiment';
import TransitionBanner from '../TransitionBanner/TransitionBanner';
import GlobalBannerContainer from '../GlobalBannerContainer/GlobalBannerContainer';
export default class Header extends React.Component {
    static propTypes = {
        conversationId: PropTypes.string,
        systemData: PropTypes.shape({}),
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        conversationId: '',
        systemData: {},
        translations: {},
    };
    render() {
        const {conversationId, systemData, translations} = this.props;
        return (
            <React.Fragment>
                <Experiment
                    name={'vrbo_web_global_messaging_banner'}
                    variant={'on'}
                >
                    <GlobalBannerContainer
                        conversationId={conversationId}
                        translations={translations}
                    />
                </Experiment>
                <SiteHeader
                    dataUrl={'/traveler/api/header'}
                    fullLocale={systemData.fullLocale}
                    currencyCode={systemData.currency}
                    siteName={systemData.site?.name}
                    theme={systemData.theme}
                    withoutCountryLanguageSelector={false}
                    withoutCurrencySelector
                    withoutLocaleSwitcher={false}
                />
                <TransitionBanner systemData={systemData} />
            </React.Fragment>
        );
    }
}
